/* unplugin-vue-components disabled */import script from "./priz_result.vue?vue&type=script&setup=true&lang=js"
export * from "./priz_result.vue?vue&type=script&setup=true&lang=js"

import "./priz_result.vue?vue&type=style&index=0&id=f52cb28a&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f52cb28a"]])

export default __exports__